module.exports = __webpack_public_path__ + "static/media/tap-791172_1920.ce53b05b.jpg";